/* ==========================================================================
   PrettyRobes — All Wedding Favors collection section
   Scoped to .af-page so listeners cannot collide with Dawn / pr-product1.js
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (!root) return;

    /* Filter panel toggle */
    var filterToggle = root.querySelector('.af-filter-toggle');
    var filtersPanel = root.querySelector('.af-filters');
    if (filterToggle && filtersPanel) {
      filterToggle.addEventListener('click', function () {
        var open = filtersPanel.dataset.open === 'true';
        filtersPanel.dataset.open = String(!open);
        filterToggle.setAttribute('aria-expanded', String(!open));
      });
    }

    /* Quick-filter chip toggles (visual only — server filtering is via collection.url params) */
    root.querySelectorAll('.af-chip').forEach(function (chip) {
      if (chip.tagName === 'A') return;
      chip.addEventListener('click', function () {
        var pressed = chip.getAttribute('aria-pressed') === 'true';
        chip.setAttribute('aria-pressed', String(!pressed));
      });
    });

    /* Sort select — submits the surrounding form so Shopify can re-render with ?sort_by=... */
    var sortSelect = root.querySelector('.af-sort select');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var form = sortSelect.closest('form');
        if (form) form.submit();
      });
    }

    /* FAQ — close peer <details> so only one is open at a time (mockup parity) */
    var faqDetails = root.querySelectorAll('.af-faq-list .af-q');
    faqDetails.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) {
          faqDetails.forEach(function (other) {
            if (other !== d) other.open = false;
          });
        }
      });
    });

    /* Smooth-scroll for in-page anchors with header offset */
    root.querySelectorAll('a.af-cta[href^="#"], a[href="#all-favors"], a[href="#best-h"], a[href="#af-grid-top"], a[href^="#chapter-"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var t = document.getElementById(id);
        if (!t) return;
        e.preventDefault();
        var hdr = document.querySelector('.pr-hdr');
        var off = hdr ? hdr.offsetHeight + 12 : 12;
        window.scrollTo({
          top: t.getBoundingClientRect().top + window.scrollY - off,
          behavior: 'smooth'
        });
      });
    });
  
  // Hero image click → smooth scroll to the grid section
  root.querySelectorAll('.hero-scroll-link').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href');
      if (href && href.charAt(0) === '#') {
        var target = document.getElementById(href.slice(1));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });

  /* Load More — fetch the next page, append its products in place, advance the
     button. Falls back to normal navigation (which lands on the grid via the
     #af-grid-top anchor, never the hero). */
  var loadMore = root.querySelector('.af-load-more');
  var prodGrid = root.querySelector('.af-prods');
  if (loadMore && prodGrid) {
    loadMore.addEventListener('click', function (e) {
      var link = e.target.closest('a');
      if (!link || link.getAttribute('aria-busy') === 'true') return;
      var href = link.getAttribute('href');
      if (!href) return;
      e.preventDefault();
      var original = link.textContent;
      link.setAttribute('aria-busy', 'true');
      link.textContent = 'Loading…';
      fetch(href, { credentials: 'same-origin' })
        .then(function (res) { if (!res.ok) throw new Error('bad status'); return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var added = doc.querySelectorAll('.af-prods .af-prod');
          if (!added.length) throw new Error('no products');
          added.forEach(function (node) { prodGrid.appendChild(node); });
          var nextLink = doc.querySelector('.af-load-more a');
          if (nextLink) {
            link.setAttribute('href', nextLink.getAttribute('href'));
            link.textContent = nextLink.textContent;
            link.removeAttribute('aria-busy');
          } else {
            loadMore.remove();
          }
        })
        .catch(function () {
          link.textContent = original;
          link.removeAttribute('aria-busy');
          window.location.assign(href);
        });
    });
  }
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.af-page').forEach(init);
    });
  } else {
    document.querySelectorAll('.af-page').forEach(init);
  }
})();
